import { Component, Input, OnInit } from '@angular/core';
import { Permissions } from 'model/shared/backend-api-response/permissions';
import { RGuestMessages } from 'model/shared/backend-api-response/rguest-messages';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { ReservationService } from 'modules/shared/legacy-bookexpress/services/reservation.service';
import { ModifyReservationsService } from 'modules/shared/services/modify-reservations.service';
import { Reservation } from 'model/shared/backend-api-response/reservation';

@Component({
  selector: 'app-compare-reservation',
  templateUrl: './compare-reservation.component.html',
  styleUrls: ['./compare-reservation.component.scss'],
})
export class CompareReservationComponent implements OnInit {
  oldReservationData: Reservation;
  currentResData: any;
  rGuestBookMessages: RGuestMessages;
  rGuestBookPermissions: Permissions;
  newRate: any = 1;
  newCurrency: any;
  currencyCode: any;
  countryCode: any;
  @Input() data: any;
  @Input() currencyDet;

  constructor(
    public config: LegacyBookInitService,
    public reservationService: ReservationService,
    public modifyResService: ModifyReservationsService
  ) {}

  ngOnInit(): void {
    // Currency Conversion Logic
    if (this.currencyDet?.currencyCode == 'USD' || this.currencyDet === 'USD') {
      this.newRate = 1;
      this.currencyCode = 'USD';
    } else {
      this.newRate = this.currencyDet['currencyValue'];
      this.currencyCode = this.currencyDet['currencyCode'];
      this.countryCode = this.currencyDet['countryCode'];
    }

    this.oldReservationData = this.modifyResService.oldRoom;
    this.currentResData = this.modifyResService.updatedRoom;

    this.rGuestBookMessages = this.config.PropertyData.rGuestMessages;
    this.rGuestBookPermissions = this.config.PropertyData.permissions;

    this.initRates();
    this.setCardDetails();
  }

  initRates() {
    const variableList = ['oldReservationData', 'currentResData'];
    for (const variable of variableList) {
      if (this[variable]?.[0]) {
        if (this[variable]?.[0]?.room?.israteAvailable && this[variable]?.[0]?.room?.isPackage) {
          this[variable][0].room.bothavailable = true;
        } else {
          this[variable][0].room.bothavailable = false;
        }
        this[variable]?.[0]?.room?.tbody?.forEach((tableObj: any, index: number) => {
          if (this[variable]?.[0]?.room.isPackage && this[variable]?.[0]?.room?.rateSnapshot?.[index]?.ratingType?.toUpperCase() === 'P') {
            tableObj.realvalue = false;
            tableObj.roomRate = 'PACKAGE';
          } else if (
            this[variable]?.[0]?.room?.hasComp &&
            this[variable]?.[0]?.room?.rateSnapshot?.[index]?.ratingType?.toUpperCase() === 'C'
          ) {
            tableObj.realvalue = false;
            tableObj.roomRate = 'COMP';
          } else {
            tableObj.realvalue = true;
          }
        });
      }
    }
  }

  setCardDetails() {
    // set old card data from existing res data
    if (this.modifyResService?.oldRoom?.length) {
      this.modifyResService.oldRoom[0].cardDetails = {
        cardLast4: this.reservationService?.reservationData?.guestInfo?.[0]?.cardLast4,
        cardTypeDesc: this.reservationService?.reservationData?.guestInfo?.[0]?.cardTypeDesc,
        cardTypeCode: this.reservationService?.reservationData?.guestInfo?.[0]?.cardTypeCode,
        cardIcon: this.modifyResService.setCardIcon(this.reservationService?.reservationData?.guestInfo?.[0]?.cardTypeCode),
        isNewCard: false,
      };
    }
  }
}
